import CSSFadeDown from '@/components/Transitions/Transitions.CSS.FadeDown'

export default {
  CSS: {
    FadeDown: CSSFadeDown,
  },
}
